import { trackEvent } from '../../helpers/analytics/trackEvent';
import { EventMykissLike } from '../../interfaces/events';

interface sendLikeEventProps {
  page: string;
  source: EventMykissLike['properties']['source'];
  type: EventMykissLike['properties']['type'];
}

export const sendLikeEvent = ({ page, source, type }: sendLikeEventProps): void => {
  void trackEvent({ name: 'mykiss_like', properties: { page, source, type } });
};
